module.exports = __webpack_public_path__ + "img/02.3e1b05a6.jpg";